export default {
  props: {
    dataSource: Array,
    size: {
      type: Number,
      required: true
    },
    isPinned: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: '100%'
    },
    remain: {
      type: Number,
      required: true
    },
    rtag: {
      type: String,
      default: 'div'
    },
    wtag: {
      type: String,
      default: 'div'
    },
    onScroll: Function
  },
  // an object helping to calculate
  delta: {
    start: 0, // start index
    end: 0, // end index
    total: 0, // all items count
    keeps: 0, // nums of item keeping in real dom
    viewHeight: 0, // container wrapper viewport height
    allPadding: 0, // all padding of not-render-yet doms
    paddingTop: 0 // container wrapper real padding-top
  },
  methods: {
    scrollToIndex (index) {
      // calculate scroll top from index and row size
      const scrollTop = Math.min(index, this.$slots.default.length - 1) * this.size
      this.scrollTo(scrollTop)
    },
    scrollTo (scrollTop) {
      this.$refs.container.scrollTop = scrollTop
    },
    getScrollTop () {
      return this.$refs.container.scrollTop
    },
    handleScroll: function (e) {
      const scrollTop = this.$refs.container.scrollTop

      this.updateZone(scrollTop)

      if (this.onScroll) {
        this.onScroll(e, scrollTop)
      }
    },
    updateZone: function (offset) {
      const delta = this.$options.delta
      const overs = Math.floor(offset / this.size)

      if (offset === 0 && delta.total) {
        this.$emit('reached-top')
      }
      // the starting list index to render
      let start = overs
      let end = overs ? overs + delta.keeps : delta.keeps
      const isOverflow = delta.total - delta.keeps > 0

      // avoid overflow range
      if (isOverflow && overs + delta.keeps >= delta.total) {
        end = delta.total
        start = delta.total - delta.keeps
        this.$emit('reached-bottom')
      }

      delta.end = end
      delta.start = start

      // call component to update shown items
      this.$forceUpdate()
    },
    filter: function (slots) {
      const delta = this.$options.delta

      if (!slots) {
        slots = []
        delta.start = 0
      }

      delta.total = slots.length
      delta.paddingTop = this.size * delta.start
      delta.allPadding = Math.max(0, this.size * (slots.length - delta.keeps))
      return slots.filter(function (slot, index) {
        return index >= delta.start && index <= delta.end
      })
    }
  },
  watch: {
    dataSource () {
      this.updateZone(0)
    }
  },
  mounted () {
    const delta = this.$options.delta // 0
    delta.viewHeight = this.$refs.container.clientHeight
    delta.start = 0
    delta.end = Math.round(delta.viewHeight / this.size) + this.remain
    delta.keeps = delta.end // 18

    this.$forceUpdate()
  },

  render (createElement) {
    const showList = this.filter(this.$slots.default)
    const delta = this.$options.delta
    let style = {
      'display': 'block',
      'overflow-y': 'auto',
      'height': this.height
    }
    if (this.isPinned) {
      style = {
        ...style,
        'position': 'absolute',
        'top': '0',
        'right': '0',
        'bottom': '0',
        'left': '0',
        'height': 'auto'
      }
    }
    return createElement(this.rtag, {
      'ref': 'container',
      'class': 'scroll-panel',
      style,
      'on': {
        'scroll': this.handleScroll
      }
    }, [
      createElement(this.wtag, {
        'style': {
          'display': 'block',
          'padding-top': delta.paddingTop + 'px',
          'padding-bottom': delta.allPadding - delta.paddingTop + 'px'
        }
      }, showList)
    ])
  }
}



// WEBPACK FOOTER //
// ./src/app/components/common/virtualScrollList/index.js